import { useCustomerIdToken } from '@hooks/customer/useCustomer';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { SWRConfiguration } from 'swr';
import { gql } from 'graphql-request';
import useSWRImmutable from 'swr/immutable';
import {
  DefaultVariables,
  GraphQLRequestWithTokenProps,
  requestWithTokenRequired,
} from '@repo/ui/src/utils/graphql-request';

interface Props {
  recipeId: string;
}

interface Variables extends DefaultVariables {
  recipeId: Props;
  pageSize: string;
}

export interface NoteProps {
  id: string;
  comment: string;
  recipeId: string;
  createdAt: string;
}
export const NoteFragment = gql`
  fragment Note on Note {
    id
    recipeId
    recipeIdAndPrivacy
    createdAt
    updatedAt
    comment
    privacy
  }
`;

export const listNotesByRecipeId = gql`
  ${NoteFragment}
  query ListNotesByRecipeId($recipeId: ID!) {
    listNotesByRecipeId(
      filter: { recipeId: $recipeId, myNotesOnly: true }
      sort: { direction: "desc", field: "createdAt" }
    ) {
      hits {
        ...Note
      }
      nextToken
    }
  }
`;

const fetcher = async (props: GraphQLRequestWithTokenProps<Variables>) => {
  const data = await requestWithTokenRequired(props);
  return data?.listNotesByRecipeId?.hits as Array<NoteProps>;
};

export const useRecipeNotes = (
  { recipeId }: Props,
  config: SWRConfiguration<Array<NoteProps> | undefined> = {},
) => {
  const idToken = useCustomerIdToken();
  const { locale } = useCurrentUrl();
  return useSWRImmutable<Array<NoteProps> | undefined>(
    {
      document: listNotesByRecipeId,
      variables: {
        recipeId,
      },
      idToken,
      locale,
    },
    fetcher,
    config,
  );
};
